// CSSをJSで直接注入（テーマのCSS読み込み問題を回避）
(function injectCSS() {
  const style = document.createElement('style');
  style.textContent = `
    .discount-progress-wrapper {
      margin-bottom: 6px;
    }
    .discount-progress-item {
      margin-bottom: 6px;
    }
    .discount-progress-text {
      font-size: 12px;
      margin-bottom: 5px;
      color: #555;
    }
    .discount-progress-text.applied {
      color: #4CAF50;
      font-weight: bold;
    }
    .discount-progress-bar-bg {
      background: #e0e0e0;
      border-radius: 7px;
      height: 7px;
      overflow: hidden;
    }
    .discount-progress-bar-fill {
      height: 100% !important;
      background: #2196F3 !important;
      border-radius: 7px !important;
      transition: width 0.4s ease !important;
      display: block !important;
      height: 7px !important;
    }
    .discount-progress-bar-fill.applied {
      background: #4CAF50 !important;
    }
  `;
  document.head.appendChild(style);
})();

const DISCOUNT_GOALS = [
  { title: '2,500円以上で300円OFF', threshold: 2500 },
  { title: '4,000円以上で500円OFF', threshold: 4000 },
  { title: '6,000円以上で850円OFF', threshold: 6000 },
  { title: '8,000円以上で1200円OFF', threshold: 8000 }
];

function updateDiscountProgress(cartTotal) {
  const container = document.getElementById('discount-progress-container');
  if (!container) return;

  // カートが空の場合は非表示
  if (cartTotal === 0) {
    container.innerHTML = '';
    return;
  }

  // 現在適用中の最上位ディスカウントを探す
  let currentApplied = null;
  let nextGoal = null;

  for (let i = 0; i < DISCOUNT_GOALS.length; i++) {
    if (cartTotal >= DISCOUNT_GOALS[i].threshold) {
      currentApplied = DISCOUNT_GOALS[i];
    } else {
      nextGoal = DISCOUNT_GOALS[i];
      break;
    }
  }

  let itemsToShow = [];

  // 適用中のバーを追加（最上位の1つだけ）
  if (currentApplied) {
    itemsToShow.push({ goal: currentApplied, applied: true });
  }

  // 次の未適用バーを追加
  if (nextGoal) {
    itemsToShow.push({ goal: nextGoal, applied: false });
  }

  container.innerHTML = itemsToShow.map(({ goal, applied }) => {
    const percent = Math.min((cartTotal / goal.threshold) * 100, 100).toFixed(1);
    const remaining = Math.max(goal.threshold - cartTotal, 0);

    return `
      <div class="discount-progress-item">
        <p class="discount-progress-text ${applied ? 'applied' : ''}">
          ${applied
            ? `✓「${goal.title}」自動適用済み`
            : `あと${remaining.toLocaleString('ja-JP')}円で「${goal.title}」適用`
          }
        </p>
        <div class="discount-progress-bar-bg">
          <div class="discount-progress-bar-fill ${applied ? 'applied' : ''}"
               style="width: ${percent}%"></div>
        </div>
      </div>
    `;
  }).join('');
}

async function fetchCartAndUpdate() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  updateDiscountProgress(cart.original_total_price / 100);
}

document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);
document.addEventListener('cart:refresh', fetchCartAndUpdate);
document.addEventListener('cart:updated', fetchCartAndUpdate);
